import axios from 'axios'

import { type ApplicationFormData } from '@/models/applicationSchema'

const client = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
})

function getCSRFToken(): string {
  const match = document.cookie.split('; ').find((row) => row.startsWith('csrf_token='))
  return match ? (match.split('=')[1] ?? '') : ''
}

client.interceptors.request.use((config) => {
  if (config.method !== 'get' && config.method !== 'head') {
    config.headers['X-CSRF-Token'] = getCSRFToken()
  }
  return config
})

interface ApplicationStatusResponse {
  status: string
  error?: string
}

interface SubmitSuccessResponse {
  success: boolean
}

export interface ValidationErrorResponse {
  errors: Record<string, string>
}

export async function getApplicationStatus(id: string): Promise<ApplicationStatusResponse> {
  const { data } = await client.get<ApplicationStatusResponse>('/application', {
    params: { id },
  })
  return data
}

export async function submitApplication(
  recordId: string,
  formData: ApplicationFormData
): Promise<SubmitSuccessResponse> {
  const { data } = await client.post<SubmitSuccessResponse>('/application', {
    recordId,
    ...formData,
  })
  return data
}
